import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom'; 
import './TypeFormPage.css'; 
import NavbarCapacita from "../../components/NavbarCapacita/NavbarCapacita";
import { validateToken } from "../../services/AuthService"
import Footer from '../../components/footer/Footer';
import Button from "../../components/button/Button";

function TypeFormPage() {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const token = localStorage.getItem("site")
  const timeoutRef = useRef()
  const [isValidate, setIsValidate] = useState(false)
  const urlTypeForm = localStorage.getItem("typeForm");
  const iframeRef = useRef(null);

  const navigate = useNavigate(); 

  const handleFormSubmit = () => {
    setFormSubmitted(true);
  };

  useEffect(() => {
    if (token) {
      validateToken(token)
        .then((response) => {
          if (response.status === 200) setIsValidate(true)
        })
        .catch((err) => {
          if (err.response && err.response.status) {
            setIsValidate(false)
            timeoutRef.current = setTimeout(() => {
              navigate("/login")
            }, 4000)
          }
        })
    } else {
      setIsValidate(false)
      navigate("/login")
    }
  }, [token, navigate])

  const handlereloadIframe = () => {
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src; // Forzar la recarga del iframe
    }
  };

  return (
    <div className="encuesta-container">
      <NavbarCapacita />
      
      {formSubmitted ? (
        <div className="gracias-message">
          ¡Gracias por completar la encuesta!
        </div>
      ) : (
        <div className="encuesta-body">
          <Button onClick={handlereloadIframe}>
            REINICIAR EVALUACIÓN
          </Button>        
          <div className="typeform-embed">
            <iframe
              ref={iframeRef}
              title="Encuesta"
              src={urlTypeForm}
              width="100%"
              height="700px"
              allow="autoplay; fullscreen; microphone; camera"
              onSubmit={handleFormSubmit}
            ></iframe>
          </div>
        </div>
      )}
       <Footer />
    </div>
  );
}

export default TypeFormPage;